import { render, staticRenderFns } from "./MarketSituationComponent.vue?vue&type=template&id=be0559da&lang=pug&"
import script from "./MarketSituationComponent.vue?vue&type=script&lang=js&"
export * from "./MarketSituationComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketSituationComponent.vue?vue&type=style&index=0&id=be0559da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports